export default "__VITE_ASSET__BaBb0DUo__"